import {AppDetail} from './modules/catalog/detail';

function productSliderInit(slider, navSlider){
    $(slider).slick({
        arrows: false,
        slidesToShow: 1,
        asNavFor: navSlider,
        infinite: false
    })

    $(navSlider).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        asNavFor: slider,
        infinite: false
    })

    $(navSlider).find('.slick-slide').on(click_event, function(e){
        $(navSlider).slick('slickGoTo', $(e.currentTarget).data('slick-index'));
    })
}

function changeQuantity(inputBlock){
    let input = $(inputBlock).find('input[type="number"]'),
        minus = $(inputBlock).find('.minus'),
        plus = $(inputBlock).find('.plus'),
        inputValue;
    
    minus.on(click_event, () => input.val() > 1 ? input.val(+input.val()-1) : input.val(1));
    plus.on(click_event, () => input.val(+input.val()+1));

    input.on('focus', ()=>{
        inputValue = input.val();
        input.val(null)
    })
    input.on('blur', ()=>{
        if(inputValue &&  input.val() == ''){
            input.val(inputValue)
        }

        if(input.val() < 1){
            input.val(1)
        }
    })

}

function recomendedSliderInit(slider){
    $(slider).slick({
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        swipeToSlide: true,
        nextArrow: '<button type="button" class="slick-next"><svg width="10" height="22" viewBox="0 0 10 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="1" d="M1.68204 1L8.27295 10.6591L1.68204 21" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        prevArrow: '<button type="button" class="slick-prev"><svg width="9" height="22" viewBox="0 0 9 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="1" d="M7.59091 1L1 10.6591L7.59091 21" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive:[
            {
                breakpoint: 1281,
                settings: {
                    arrows: false
                }
            },
            {
                breakpoint: 1240,
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 890,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 606,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                }
            },
        ]
    })
}


$(function(){
    productSliderInit('.product-slider', '.nav-slider');
    changeQuantity('.price-block .quantity');
    if($('.recomended-slider').length != 0){
        recomendedSliderInit('.recomended-slider');
    }

    $('.characteristics-wrapper .characteristic-item').on(click_event, function(){
        $(this).addClass('active').siblings().removeClass('active')
    });

    // инициализация работы с характеристиками в карточке товара
    new AppDetail('catalog-item-detail', window.app_product_detail);
})